elabs.RecentlyViewed = class {
  static STORAGE_KEY = 'viewedProducts';
  static MAX_PRODUCTS = 12;

  static addProduct(productId) {
    if (productId === null || productId === undefined) {
      return;
    }
    const id = Number(productId);
    if (Number.isNaN(id)) {
      return;
    }

    let viewed = this.getProducts();
    viewed = viewed.filter((existing) => existing !== id);
    viewed.unshift(id);
    viewed = viewed.slice(0, this.MAX_PRODUCTS);

    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(viewed));
    } catch (e) {
      console.warn('RecentlyViewed: failed to write to localStorage', e);
    }
  }

  static getProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
      return stored.map(Number).filter((id) => !Number.isNaN(id));
    } catch {
      return [];
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch (e) {
      console.warn('RecentlyViewed: failed to clear localStorage', e);
    }
  }
};
